import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import MolstarViewer, {MOLSTAR_PREVIEW_TYPE_TO_FORMAT} from 'molbio/molstar/ViewerWrapper';
import {
  STICKY_FOOTER_CONTAINER_STYLES,
  STICKY_FOOTER_CONTENT_STYLES,
} from 'molbio/proteins/alphafold/structure-prediction/StickyFooter';
import StructurePredictionInfo from 'molbio/proteins/alphafold/StructurePredictionInfo';
import Button, {ButtonLink, ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {type GenerativeModelRun} from './GenerativeModelsRunsList';

export default function GenerativeModelRunDetails({
  run,
  navigateToList,
}: {
  run: GenerativeModelRun;
  navigateToList: () => void;
}): JSX.Element {
  if (!run.topPredictedStructureFile?.redirectUrl) {
    return <div>No structure file found</div>;
  }

  return (
    <div className={css(styles.outerContainer)}>
      <div className={css(styles.content)}>
        <div className={css(styles.contentPadding)}>
          <div className={css(styles.buttonContainer)}>
            <Button
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
              size={ButtonSize.SMALL}
              icon="chevron-left"
              text="View all runs"
              onClick={navigateToList}
            />

            <StructurePredictionInfo
              model="BoltzGen"
              modelVersion="0.1.2"
              className={css(styles.predictionInfo)}
            />

            <ButtonLink
              text="Download generated structures"
              buttonStyle={ButtonStyle.PRIMARY}
              icon="download"
              size={ButtonSize.SMALL}
              href={run.zippedFullResultsFile?.redirectUrl}
              target="_blank"
              rel="noopener noreferrer"
            />
          </div>
        </div>

        <div className={css(styles.viewerWrapper)}>
          <MolstarViewer
            url={run.topPredictedStructureFile.redirectUrl}
            format={MOLSTAR_PREVIEW_TYPE_TO_FORMAT[EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER]}
            className={classNames('reset', css(styles.viewer))}
          />
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  outerContainer: STICKY_FOOTER_CONTAINER_STYLES,
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  content: {
    ...STICKY_FOOTER_CONTENT_STYLES,
    display: 'flex',
    flexDirection: 'column',
  },
  contentPadding: {
    padding: '20px',
    flexShrink: 0,
  },
  viewer: {
    borderWidth: '0px',
    flex: '1 1 auto',
  },
  viewerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0%',
    minHeight: 0,
  },
  predictionInfo: {
    margin: '0',
  },
});
